import type { CSSProperties } from 'react';

export const RATING_SCALE_COLUMN_MAX_WIDTH = '4rem';
export const RATING_SCALE_GRID_CLASS = 'grid justify-center gap-x-2 gap-y-3';
export const RATING_SCALE_CIRCLE_CLASS =
  'w-full max-w-12 aspect-square justify-self-center rounded-full border-2 font-semibold transition-all duration-200';
export const RATING_SCALE_END_LABEL_CLASS = 'text-xs text-gray-500 text-center hyphens-auto';
const LABEL_ROW = 2;

export function ratingScaleGridStyle(pointCount: number): CSSProperties {
  return {
    gridTemplateColumns: `repeat(${pointCount}, minmax(0, ${RATING_SCALE_COLUMN_MAX_WIDTH}))`,
  };
}

export function ratingScaleEndLabelStyle(column: number): CSSProperties {
  return { gridColumn: String(column), gridRow: String(LABEL_ROW) };
}
